import { render, staticRenderFns } from "./MyProjectsCreatedAndWatched.vue?vue&type=template&id=fb8165de"
import script from "./MyProjectsCreatedAndWatched.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyProjectsCreatedAndWatched.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports